import React from 'react';
import { NavLink } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaPhoneAlt, FaHandshake, FaRegEnvelope, FaSms, FaTrash } from 'react-icons/fa';
import { FaWhatsapp, FaPencilAlt, FaFileAlt, FaMoneyBillWave } from 'react-icons/fa';

import CustomerAPI from '../../api/CustomerAPI';
import ApiUiController from '../../controller/ApiUiController';

import CallPopup from '../call/CallPopup';
import MeetingPopup from '../meeting/MeetingPopup';
import DocumentPopup from '../meeting/DocumentPopup';
import SmsPopup from '../sms/SmsPopup';
import EmailPopup from '../email/EmailPopup';
import WhatsAppPopup from '../whatsapp/WhatsAppPopup';

import InnerCallList from '../call/InnerCallList';
import InnerMeetingList from '../meeting/InnerMeetingList';
import InnerDocumentList from '../document/InnerDocumentList';
import InnerSmsList from '../sms/InnerSmsList';
import InnerEmailList from '../email/InnerEmailList';
import InnerSalesOrderList from '../sales_order/InnerSalesOrderList';
import InnerContactList from '../contact/InnerContactList';

import CustomerDetails from './CustomerDetails';
import CustomerInformation from './CustomerInformation';

import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import Display from '../../util/Display';

import './CustomerPreview.css';

class CustomerPreview extends React.Component {

  static Refresh = 'refresh';
  static Call = 'call';
  static Meeting = 'meeting';
  static Document = 'document';
  static SMS = 'sms';
  static Email = 'email';
  static WhatsApp = 'whats-app';
  static SalesOrder = 'sales-order';
  static Contact = 'contact';
  
  constructor(props) {
    super(props);
    
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.customer;
    this.id = parseInt(props.match.params.customerId);

    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
    
    this.state = { inApiCall: this.id !== 0 , popup: null,
      call: null,  meeting: null, document: null, email: 0, sms: 0, whatsApp: 0 };

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);

    this.CallList = Util.isAllow(this.models.call.permission, Const.PermView);
    this.CallAdd = Util.isAllow(this.models.call.permission, Const.PermAdd);
    
    this.CallUpdate = Util.isAllow(this.models.call.permission, Const.PermUpdate);

    this.MeetList = Util.isAllow(this.models.meeting.permission, Const.PermView);
    this.MeetAdd = Util.isAllow(this.models.meeting.permission, Const.PermAdd);
    this.MeetUpdate = Util.isAllow(this.models.meeting.permission, Const.PermUpdate);

    this.DocList = Util.isAllow(this.models.document.permission, Const.PermView);
    this.DocAdd = Util.isAllow(this.models.document.permission, Const.PermAdd);

    this.SmsList = Util.isAllow(this.models.sms.permission, Const.PermView);
    this.SmsAdd = Util.isAllow(this.models.sms.permission, Const.PermAdd);

    this.EmailList = Util.isAllow(this.models.email.permission, Const.PermView);
    this.EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);

    this.SalesList = Util.isAllow(this.models.sales_order.permission, Const.PermView);
    this.SalesAdd = Util.isAllow(this.models.sales_order.permission, Const.PermAdd);
  }

  componentDidMount() { if(this.id !== 0){CustomerAPI.get(this.id, this.onReceived, this.onFail);}}

 onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  onReceived = res => {
    this.customer = res;
    this.setState({ ...this.state, inApiCall: false });
  }

  onUpdate = () => {
    this.setState({ ...this.state, inApiCall: true });
    CustomerAPI.get(this.id, this.onReceived, this.onFail);
  };
  onDelete = () => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.customer)}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      CustomerAPI.delete(this.customer.id, this.onDeleteSuccess,  this.onFail);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Customer deleted successfully', 'success');
    this.props.navigate('/customer');
  }

  updateMater = () => {
    this.setState({ inApiCall: true, popup: null });
    CustomerAPI.get(this.id, this.onReceived, this.onFail);
  }

  showDetails = (model, field) => {
    if(field === CustomerPreview.SalesOrder) {
      this.props.navigate(`/sales-order/preview/${model}`);
      return;
    } else if(field === CustomerPreview.Contact) {
      this.props.navigate(`/contact/preview/${model}`);
      return;
    }
  }
  showPopUp = (model, field) => {
    if(field === CustomerPreview.SalesOrder) {
      this.props.navigate(`/sales-order/add-edit/1/${this.id}/${model}`);
      return;
    } 
    let tmp = {...this.state};
    tmp[field] = model;
    tmp.popup = field;
    this.setState({ ...tmp});
  }
  
  render() {
    const EmailOpt = this.customer && this.customer.email_opt && this.customer.email_opt === Const.True;
    const SmsOpt = this.customer && this.customer.sms_opt && this.customer.sms_opt === Const.True;
    return (
      <section className="previewpage"> 
        
        <ApiUiController inApiCall={this.state.inApiCall}>

          { (this.CallAdd || this.CallUpdate) &&
            <CallPopup show={this.state.popup === CustomerPreview.Call} onHide={this.hidePopUp}
              call={this.state.call}
              reload={this.updateMater} model_no={Const.Customer} model_id={this.id} />
          }

          { (this.MeetAdd || this.MeetUpdate) &&
            <MeetingPopup show={this.state.popup === CustomerPreview.Meeting}
              onHide={this.hidePopUp} meeting={this.state.meeting}
              reload={this.updateMater} model_no={Const.Customer} model_id={this.id} />
          }

          { this.DocAdd &&
            <DocumentPopup show={this.state.popup === CustomerPreview.Document}
              onHide={this.hidePopUp} document={this.state.document}
              reload={this.updateMater} model_no={Const.Customer} model_id={this.id} />
          }

          { this.SmsAdd &&
            <SmsPopup show={this.state.popup === CustomerPreview.SMS} onHide={this.hidePopUp}
              data={this.customer} model={this.model}
              reload={this.updateMater} model_no={Const.Customer} model_id={this.id} />
          }
          
          { this.EmailAdd &&
            <EmailPopup show={this.state.popup === CustomerPreview.Email} onHide={this.hidePopUp}
              data={this.customer} model={this.model}
              reload={this.updateMater} model_no={Const.Customer} model_id={this.id} />
          }

          <WhatsAppPopup show={this.state.popup === CustomerPreview.WhatsApp} onHide={this.hidePopUp}
            data={this.customer} model={this.model} />
          
          <div className="container-fluid">  
            <div className="row lead-mt">
              <div className="col-md-3">
                <div className="title_page">
                  <h2>Customer - {this.customer && Display.ModelName(this.customer)}</h2>
                </div>
              </div>
              <div className="col-md-9 lead-btns-col">
                <span className="action-btns-lg">
                  { this.CallAdd &&
                    <span className="buttons call" variant="primary"
                      onClick={() => this.showPopUp(null, CustomerPreview.Call)}><FaPhoneAlt /> Call
                    </span>
                  }
                  { this.MeetAdd &&
                    <span className="buttons meeting" variant="primary"
                      onClick={() => this.showPopUp(null, CustomerPreview.Meeting)}><FaHandshake /> Meeting
                    </span>
                  }
                  { this.DocAdd &&
                    <span className="buttons junk" variant="primary"
                      onClick={() => this.showPopUp(null, CustomerPreview.Document)}><FaFileAlt /> Doc
                    </span>
                  }
                  { this.SmsAdd && !SmsOpt ?
                    <span className="buttons sms" variant="primary"
                      onClick={() => this.showPopUp({}, CustomerPreview.SMS)}><FaSms /> SMS
                    </span>
                    : null
                  }
                  { this.EmailAdd && !EmailOpt ?
                    <span className="buttons email" variant="primary"
                      onClick={() => this.showPopUp({}, CustomerPreview.Email)}><FaRegEnvelope /> Email
                    </span>
                    : null
                  }
                  <span className="buttons whtsapp" variant="primary"
                    onClick={() => this.showPopUp({}, CustomerPreview.WhatsApp)}><FaWhatsapp /> WhatsApp
                  </span>
                  { this.SalesAdd ?
                    <span className="buttons sales" variant="primary">
                      <NavLink to={`/sales-order/add-edit/1/${this.id}/0`}><FaMoneyBillWave /> Sales
                      </NavLink>
                    </span>
                    : null
                  }
                  { /*this.ContactAdd &&
                    <span className="buttons sales" variant="primary"
                      onClick={() => this.showPopUp(null, CustomerPreview.Contact)}><FaUser /> Contact
                    </span>
                  */}
                  { this.Update ?
                    <span className="buttons update" variant="primary">
                      <NavLink to={`${this.base}/add-edit/${this.id}`}><FaPencilAlt /> Update</NavLink>
                    </span>
                    : null
                  }
                  { this.Delete ?
                    <span className="buttons delete" onClick={this.onDelete}><FaTrash/> Delete</span>
                    : null
                  }
                </span>
              </div>
            </div>

            <div className="row tablesrow">
              <div className="col-md-8">
                <CustomerDetails model={this.model} lead={this.customer} leadName={this.customer && Display.ModelName(this.customer)} />
                <CustomerInformation model={this.model} lead={this.customer} />
                { /* <LeadProgress /> */ }
                
                { this.CallList &&
                  <InnerCallList id={this.id} type={Const.Customer}
                    reload={this.updateMater} edit={this.showPopUp} />
                }
                { this.MeetList &&
                  <InnerMeetingList id={this.id} type={Const.Customer}
                    edit={this.showPopUp} reload={this.updateMater}/>
                }
                { this.DocList &&
                  <InnerDocumentList id={this.id} type={Const.Customer}
                    reload={this.updateMater}/>
                }
                { this.SmsAdd &&
                  <InnerSmsList id={this.id} type={Const.Customer} reload={this.updateMater} />
                }
                { this.EmailList &&
                  <InnerEmailList id={this.id} type={Const.Customer} reload={this.updateMater} />
                }

                { this.SalesList &&
                  <InnerSalesOrderList id={this.id} type={Const.Customer}
                    reload={this.updateMater} show={this.showDetails} edit={this.showPopUp} />
                }

                { this.ContactList &&
                  <InnerContactList id={this.id} type={Const.Customer}
                    reload={this.updateMater} show={this.showDetails} edit={this.showPopUp} />
                }
              </div>
            </div>
          </div>
        </ApiUiController>
      </section>
    );
  }
}
export default withRouter(CustomerPreview);